import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { User } from "lucide-react";

/** Loads a private santri photo as a blob URL (auth cookies are sent automatically). */
export default function SantriPhoto({ path, alt, className = "h-10 w-10 rounded-full object-cover bg-emerald-50" }) {
  const [src, setSrc] = useState(null);

  useEffect(() => {
    let mounted = true;
    let blobUrl = null;
    if (!path) {
      setSrc(null);
      return;
    }
    (async () => {
      try {
        const res = await api.get(`/files/${path}`, { responseType: "blob" });
        blobUrl = URL.createObjectURL(res.data);
        if (mounted) setSrc(blobUrl);
      } catch (_e) {
        if (mounted) setSrc(null);
      }
    })();
    return () => {
      mounted = false;
      if (blobUrl) URL.revokeObjectURL(blobUrl);
    };
  }, [path]);

  if (!src) {
    return (
      <div className={`${className} flex items-center justify-center text-emerald-700`}>
        <User className="h-5 w-5" />
      </div>
    );
  }
  return <img src={src} alt={alt || "foto"} className={className} />;
}
